import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import AuthenticationService from '../services/AuthenticationService'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState({
    paths: ['user'] // Keep only user
  })],
  state: {
    transactions: {},
    subscriptions: {},
    users: {},
    webhooklogs: {},
    activeCognitoGroup: '',
    searchValue: '',
    error: '',
    dateRange: {},
    calendar: false,
    drawer: false,
    user: {
      roles: [],
      activeCognitoGroup: '',
      allowedCognitoGroups: [],
      email: ''
    },
    pagination: {
      sortBy: 'createdAt',
      descending: true,
      page: 1,
      rowsPerPage: 20
    },
    pagination2: {
      page: 1,
      rowsPerPage: 1
    }
  },
  mutations: {
    setUserEmail (state, user) {
      state.user.email = user.email
    },
    setPagination (state, pagination) {
      state.pagination = pagination
    },
    setPagination2 (state, pagination) {
      state.pagination2 = pagination
    },
    setDrawer (state, drawer) {
      state.drawer = drawer
    },

    setError (state, error) {
      state.error = error
    },

    setCalendar (state, calendar) {
      state.calendar = calendar
    },

    setSearchValue (state, searchValue) {
      state.searchValue = searchValue
    },

    setDateRange (state, dateRange) {
      state.dateRange = dateRange
    },

    setTransactions (state, transactions) {
      state.transactions = transactions
    },

    setSubscriptions (state, subscriptions) {
      // subscriptions.docs = subscriptions.docs.map(sub => {
      //   sub.carrier = sub.transactions.map(t => t.carrier)[0]
      //   return sub
      // })
      state.subscriptions = subscriptions
    },

    setUsers (state, users) {
      state.users = users
    },

    setWebhooklogs (state, webhooklogs) {
      state.webhooklogs = webhooklogs
    },

    setUserRoles (state, roles) {
      state.user.roles = roles
    },

    setActiveCognitoGroup (state, group) {
      state.user.activeCognitoGroup = group
    },

    setAllowedCognitoGroups (state, groups) {
      state.user.allowedCognitoGroups = groups
    }
  },
  getters: {
    getUserRoles: state => state.user.roles,
    isUserInRole: state => roles => AuthenticationService.isInRole(roles, state.user.roles),
    getTransactions: state => state.transactions,
    getUsers: state => state.users,
    getSubscriptions: state => state.subscriptions,
    getActiveCognitoGroup: state => state.user.activeCognitoGroup,
    allowedCognitoGroups: state => state.user.allowedCognitoGroups
  },
  actions: {
    sortTransactions ({ state, dispatch, commit }) {
      const { sortBy, descending } = state.pagination
      const transactions = state.transactions
      if (transactions && Object.keys(transactions).length !== 0) {
        const items = transactions.docs.slice()
        items.forEach(item => {
          dispatch('formatProductData', { productData: item.productData, value: 'referenceNumber' })
            .then(result => {
              item.productName = result
            })
            .then(() => dispatch('formatProductData', { productData: item.productData, value: 'periodLenght' }))
            .then(result => {
              item.periodLenght = result
            })
        })
        if (sortBy) {
          dispatch('sort', { sortBy, items, descending })
            .then(result => {
              transactions.docs = result
            })
            .then(() => commit('setTransactions', transactions))
        }
      }
    },
    sortSubscriptions ({ state, dispatch, commit }) {
      const { sortBy, descending } = state.pagination
      const subscriptions = state.subscriptions
      if (subscriptions && Object.keys(subscriptions).length !== 0) {
        const items = subscriptions.docs.slice()
        if (sortBy) {
          dispatch('sort', { sortBy, items, descending })
            .then(result => {
              subscriptions.docs = result
            })
            .then(() => commit('setSubscriptions', subscriptions))
        }
      }
    },
    sortUsers ({ state, dispatch, commit }) {
      const { sortBy, descending } = state.pagination
      const users = state.users
      if (users && Object.keys(users).length !== 0) {
        const items = users.slice()
        items.forEach(item => {
          dispatch('formatUserInfo', { Attributes: item.Attributes, key: 'email' })
            .then(result => {
              item.email = result
            })
            .then(() => dispatch('formatUserInfo', { Attributes: item.Attributes, key: 'name' }))
            .then(result => {
              item.name = result
            })
            .then(() => dispatch('formatUserInfo', { Attributes: item.Attributes, key: 'role' }))
            .then(result => {
              item.role = result
            })
        })
        if (sortBy) {
          dispatch('sort', { sortBy, items, descending })
            .then(result => {
              users.docs = result
            })
            .then(() => commit('setUsers', users))
        }
      }
    },
    sortWebhooklogs ({ state, dispatch, commit }) {
      const { sortBy, descending } = state.pagination
      const webhooklogs = state.webhooklogs
      if (webhooklogs && Object.keys(webhooklogs).length !== 0) {
        const items = webhooklogs.docs.slice()
        if (sortBy) {
          dispatch('sort', { sortBy, items, descending })
            .then(result => {
              webhooklogs.docs = result
            })
            .then(() => commit('setWebhooklogs', webhooklogs))
        }
      }
    },
    formatProductData (context, { productData, value }) {
      if (Array.isArray(productData) && productData[0]) {
        const productArray = []
        productData.forEach((productData) => {
          if (value === 'periodLenght') productArray.push(productData.periodLenght)
          if (value === 'referenceNumber') productArray.push(productData.referenceNumber)
        })
        return productArray.toString()
      } else {
        return ''
      }
    },
    formatUserInfo (context, {Attributes, key}) {
      if (Array.isArray(Attributes)) {
        const usersArray = []
        for (const attribute of Attributes) {
          if (attribute.Name === 'email' & key === 'email') {
            usersArray.push(attribute.Value.toString())
          }
          if (attribute.Name === 'name' & key === 'name') {
            usersArray.push(attribute.Value.toString())
          }
          if (attribute.Name === 'custom:role' & key === 'role') {
            usersArray.push(attribute.Value.toString())
          }
        }
        return usersArray.toString()
      } else {
        return ''
      }
    },
    sort (context, { sortBy, items, descending }) {
      return items.sort((a, b) => {
        const sortA = a[sortBy]
        const sortB = b[sortBy]
        if (descending) {
          if (sortA === null) return 1
          if (sortB === null) return -1
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA === null) return -1
          if (sortB === null) return 1
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/Store.js